export default __webpack_public_path__ + "static/media/PANS_logo-z-napisem2.6c866806.png";